<template src="./template.html"></template>

<script>
  import { clone, assign } from 'lodash'
  import vueDropzone from 'vue2-dropzone'
  import Cookie from 'js-cookie'

  export default {
    name: 'ImageUploader',
    components: {
      vueDropzone,
    },
    props: {
      userId: Number,
      type: String,
      title: String,
      customizedStyles: String,
      uploadTitle: String,
      uploadSubTitle: String,
      config: null,
    },
    data() {
      return {
        image: {
          url: null,
          id: null,
        },
        baseConfig: {
          url: `${process.env.VUE_APP_API_URL}groups/image`,
          maxFiles: 1,
          addRemoveLinks: true,
          maxFilesize: 20,
          dictRemoveFile: this.$t('dropzone.actions.remove_file'),
          dictCancelUpload: this.$t('dropzone.actions.cancel_upload'),
          headers: {
            'X-CSRF-Token': Cookie.get('intranet_csrf_token') || null,
          },
        },
      }
    },
    computed: {
      imageUploaderConfig() {
        return assign({}, this.baseConfig, this.config)
      },
    },
    methods: {
      dropzoneChangeUrl() {
        this.userId && this.$refs.dropzone.setOption('url', `${process.env.VUE_APP_API_URL}users/${this.userId}/image`)
      },
      onPickFile(resp) {
        if (resp.status !== 'success') return

        this.image.url = JSON.parse(resp.xhr.response).url
        this.image.id = JSON.parse(resp.xhr.response).id
        this.$refs.dropzone.disable()

        if (this.type === 'groups' && this.image) {
          this.onSetNewImage(this.image.id)
        }
      },
      onRemoveFile(file) {
        if (file.status !== 'success') return

        this.image.url = null
        this.image.id = null
        this.$refs.dropzone.enable()
      },
      removeFile(file) {
        this.$refs.dropzone.removeFile(file)
      },
      onSave($event) {
        this.$emit('onSaveUpload', clone(this.image))

        if ($event) {
          $event.preventDefault()
        }
      },
      onSetNewImage(value) {
        this.$emit('onSetNewImage', value)
      },
    },
  }
</script>
